import styled, { css } from 'styled-components';
import { COLORS } from '@app/src/ui';

interface Props {
  checked?: boolean;
  colorActive?: string;
  disabled?: boolean;
}

export const Mask = styled.span`
  cursor: pointer;
  height: 20px;
  width: 20px;
  flex: 0 0 20px;
  border-radius: 4px;
  border: 2px solid ${COLORS.GRAY_TEXT};
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    display: none;
    margin-top: -2px;
  }
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  ${(props: Props) => props.checked && css`
    & input ~ span {
      border: ${(props:Props) =>  props.colorActive && `2px solid ${props.colorActive}`};
      background: ${(props:Props) =>  props.colorActive && `${props.colorActive}`};
    }
    & input ~ span svg {
      display: block;
    }
  `}

  ${(props: Props) => props.disabled && css`
    pointer-events: none;
    user-select: none;
    cursor: not-allowed;
    opacity: 0.7;
  `}
`;

export const Hidden = styled.input`
  position: absolute;
  display: none;
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 11px;
  display: block;
`;
